import { render } from "./Tutorial.vue?vue&type=template&id=a2228a16"
import script from "./Tutorial.vue?vue&type=script&lang=js"
export * from "./Tutorial.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tour/Tutorial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2228a16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2228a16', __exports__)) {
    api.reload('a2228a16', __exports__)
  }
  
  module.hot.accept("./Tutorial.vue?vue&type=template&id=a2228a16", () => {
    api.rerender('a2228a16', render)
  })

}


export default __exports__